import { z } from 'zod';
// ---------- F18 Hitos de pago ----------
export const MilestoneStatusSchema = z.enum(['PENDIENTE', 'FACTURADO']);
export const MilestoneStatusLabel = {
    PENDIENTE: 'Pendiente',
    FACTURADO: 'Facturado',
};
const decimalString = z
    .union([z.number(), z.string()])
    .transform((v) => (typeof v === 'number' ? v.toString() : v));
export const MilestoneItemInputSchema = z.object({
    position: z.number().int().min(0).default(0),
    title: z.string().min(1).max(300),
    description: z.string().max(2000).nullable().optional(),
    /** Base imponible en céntimos; el IVA se aplica al facturar. */
    amountCents: z.number().int(),
    vatRate: decimalString.default('0.21'),
    dueDate: z.string().datetime(),
});
/** Alta en bloque: un plan de pagos completo de una vez. */
export const CreateMilestonesSchema = z.object({
    clientId: z.string(),
    caseId: z.string().nullable().optional(),
    quoteId: z.string().nullable().optional(),
    items: z.array(MilestoneItemInputSchema).min(1).max(50),
});
export const UpdateMilestoneSchema = z.object({
    title: z.string().min(1).max(300).optional(),
    description: z.string().max(2000).nullable().optional(),
    amountCents: z.number().int().optional(),
    vatRate: decimalString.optional(),
    dueDate: z.string().datetime().optional(),
});
/** Facturar una selección de hitos pendientes (mismo cliente). */
export const InvoiceMilestonesSchema = z.object({
    ids: z.array(z.string()).min(1).max(50),
});
export const MilestoneDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    clientDisplayName: z.string(),
    caseId: z.string().nullable(),
    caseCode: z.string().nullable(),
    quoteId: z.string().nullable(),
    quoteNumber: z.string().nullable(),
    position: z.number().int(),
    title: z.string(),
    description: z.string().nullable(),
    amountCents: z.number().int(),
    vatRate: z.string(),
    dueDate: z.string(),
    status: MilestoneStatusSchema,
    invoiceId: z.string().nullable(),
    invoiceNumber: z.string().nullable(),
    createdAt: z.string(),
});
export const MilestoneListResponseSchema = z.object({
    items: z.array(MilestoneDtoSchema),
    total: z.number().int(),
    /** Suma de bases pendientes del filtro actual, en céntimos. */
    pendingAmountCents: z.number().int(),
});
//# sourceMappingURL=milestones.js.map